// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3wfHN","buttons":"PendingPaymentAlert_buttons__1R1Ek"};